import { Accordion, AccordionDetails, Typography } from "@mui/material";
import { AccordionSummaryWithSpacing } from "./styled/AccordionSummaryWithSpacing.tsx";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionInfo } from "../types/AccordionInfo.ts";
import { trackEvent } from "../util/analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";
import { SyntheticEvent } from "react";

type InfoAccordionProps = {
  info: AccordionInfo;
  analyticsCategory: EventCategory;
  expanded: boolean;
  onChange: (_event: SyntheticEvent, isExpanded: boolean) => void;
};

export const InfoAccordion = ({
  info,
  analyticsCategory,
  expanded,
  onChange,
}: InfoAccordionProps) => {
  const handleExpand = () => {
    trackEvent(analyticsCategory, "expand", info.title);
  };

  return (
    <Accordion expanded={expanded} onChange={onChange}>
      <AccordionSummaryWithSpacing
        expandIcon={<ExpandMoreIcon />}
        onClick={handleExpand}
      >
        <Typography variant={"h6"}>{info.title}</Typography>
      </AccordionSummaryWithSpacing>
      <AccordionDetails sx={{ paddingTop: 0 }}>{info.body}</AccordionDetails>
    </Accordion>
  );
};
